// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"343aed74","590":"f6669234"}[chunkId] + ".chunk.css";
};